import script from "./ProjectRequestedDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectRequestedDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectRequestedDetailPage.vue?vue&type=style&index=0&id=7212297d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7212297d"]])

export default __exports__